import { createSlice } from "@reduxjs/toolkit";

import { Vehicle } from "../../Interfaces/vehicle.type";

const initialState = {
  selectedForDelivery: [],
};

export const bookDeliverySlice = createSlice({
  name: "BOOK_DELIVERY",
  initialState,
  reducers: {
    TOGGLE_DELIVERY_CHECKBOX: (state, action) => {
      if (
        state.selectedForDelivery.some(
          (vehicle: Vehicle) => vehicle.vrm === action.payload.vrm
        )
      ) {
        state.selectedForDelivery = state.selectedForDelivery.filter(
          (vehicle: Vehicle) => vehicle.vrm !== action.payload.vrm
        );
      } else {
        state.selectedForDelivery = [
          ...state.selectedForDelivery,
          action.payload,
        ];
      }
    },
    REMOVE_VEHICLE: (state, action) => {
      state.selectedForDelivery = state.selectedForDelivery.filter(
        (vehicle: Vehicle) => vehicle.vrm !== action.payload.vrm
      );
    },
    CLEAR_ALL: (state) => {
      state.selectedForDelivery = initialState.selectedForDelivery;
    },
  },
});

export const { TOGGLE_DELIVERY_CHECKBOX, REMOVE_VEHICLE, CLEAR_ALL } =
  bookDeliverySlice.actions;
export default bookDeliverySlice.reducer;
